module.exports = __webpack_public_path__ + "static/assets/715b2eeeb3a4bf4b24499cbf701ab6ca.png";